/* globals jQuery */
import { easing, animSpeed, globalContext } from '../js_partials/_vars.js';
// import 'html5shiv';
import 'jquery.easing'; // Used for `easing` in jQuery methods
import '../js_partials/_notification.js';
import '../js_partials/_menu.js';
import '../js_partials/_faq.js';
import '../js_partials/_modal.js';
import '../js_partials/_lightbox.js';
import '../js_partials/_feedback-contact.js';
import '../js_partials/_register.js';
import '../js_partials/_validation.js';

let { messageTimeout } = globalContext;
let paused
const slideShowInterval = 8000;

(function(window, document, $) {
	function slideshowAuto(e) {
		var $active = $(e).find('li.active');
		if ( $active.length === 0 ) {
			$active = $(e).find('li:last');
		}
		var $next =  $active.next().length ? $active.next()
		: $(e).find('li:first');
		$active.addClass('last-active');
		$next.css({opacity: 0.0})
		.addClass('active')
		.animate({opacity: 1.0}, 1500, function() {
			$active.removeClass('active last-active');
		});
	}

	function slideshowNext(e) {
		var $active = $(e).find('li.active');
		if ( $active.length === 0 ) {
		$active = $(e).find('li:last');
		}
		var $next =  $active.next().length ? $active.next()
		: $(e).find('li:first');
		$active.addClass('last-active');
		$next.css({opacity: 1.0}).addClass('active');
		$active.removeClass('active last-active');
	}

	function slideshowBack(e) {
		var $active = $(e).find('li.active');
		if ( $active.length === 0 ) {
		$active = $(e).find('li:first');
		}
		var $prev =  $active.prev().length ? $active.prev()
		: $(e).find('li:last');
		$active.addClass('last-active');
		$prev.css({opacity: 1.0}).addClass('active');
		$active.removeClass('active last-active');
	}

	function imageSwitch(e) {
		var $active = $(e).find('img.active');

		if ( $active.length === 0 ) {
		$active = $(e).find('img:last');
		}

		var $next =  $active.next().length ? $active.next()
		: $(e).find('img:first');

		$active.addClass('last-active').removeClass('active');

		$next.css({ opacity: 0 }).addClass('active')
		.animate({ opacity: 1 }, 1000, function() {
			$active.css({ opacity: 0 }).removeClass('last-active');
		});
	}

	$.fn.clickToggle = function(func1, func2) {
		var funcs = [func1, func2];
		this.data('toggleclicked', 0);
		this.click(function() {
			var data = $(this).data();
			var tc = data.toggleclicked;
			$.proxy(funcs[tc], this)();
			data.toggleclicked = (tc + 1) % 2;
		});
		return this;
	};

	$(document).ready(function() {
		// Apply placeholder text styles to all valueless selectmenus by default
		$('.custom-select').each(function(){
			if (this.value === '') {
				$(this).addClass('selectmenu-placeholder');
			}
		});

		$(document).on('change', '.custom-select', function({ target }){
			if (target.value) {
				$(this).removeClass('selectmenu-placeholder');
			}
		});

		$('#get-list-button').on('click', function(e){
			$('.notification').remove();
			clearTimeout(messageTimeout);

			var clickBtnValue = $(this).attr('name'),
			url = '/_inc/ajax-actions.php',
			data =  {'action': clickBtnValue};
			$.ajax({
				type: "POST",
				url: url,
				data: data,
				success: function(response, status, xhr) {
					// check for a filename
					var filename = "";
					var disposition = xhr.getResponseHeader('Content-Disposition');
					if (disposition && disposition.indexOf('attachment') !== -1) {
						var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
						var matches = filenameRegex.exec(disposition);
						if (matches !== null && matches[1]){
							filename = matches[1].replace(/['"]/g, '');
						}
					}

					var type = xhr.getResponseHeader('Content-Type');
					var blob = new Blob([response], { type: type });

					if (typeof window.navigator.msSaveBlob !== 'undefined') {
						// IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
						window.navigator.msSaveBlob(blob, filename);
					} else {
						var URL = window.URL || window.webkitURL;
						var downloadUrl = URL.createObjectURL(blob);

						if (filename) {
							// use HTML5 a[download] attribute to specify filename
							var a = document.createElement("a");
							// safari doesn't support this yet
							if (typeof a.download === 'undefined') {
								window.location = downloadUrl;
							} else {
								a.href = downloadUrl;
								a.download = filename;
								document.body.appendChild(a);
								a.click();
							}
						} else {
							window.location = downloadUrl;
						}

						setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
					}

					$('<p style="max-width: 280px;" class="notification notification-successful">Your file has been created.<br/>If the file didn\'t open up in a new window, please check your "Downloads" folder.</p>')
					.hide().insertAfter(e.target).fadeTo(animSpeed, 1, easing);

					messageTimeout = setTimeout(function(){
						$('.notification').fadeTo(animSpeed, 0, easing, function(){
							$(this).remove();
						});
					}, 5000);
				},
				error: function(){
					$('<p class="notification notification-error">There was an error creating your file.</p>')
					.hide().insertAfter(e.target).fadeTo(animSpeed, 1, easing);

					messageTimeout = setTimeout(function(){
						$('.notification').fadeTo(animSpeed, 0, easing, function(){
							$(this).remove();
						});
					}, 5000);
				}
			});
		});

		if (navigator.userAgent.indexOf("MSIE 10") > -1) {
			document.body.classList.add("ie10");
		}

		$(function() {
			var y = new Date();
			var n = y.getFullYear();
			$('#copyright').append('&copy; ' + n + ' Image Transfers &ndash; Custom Rub Down Dry Transfers &ndash; All Rights Reserved');
		});
		$('#place-order-four').on('click touchend', function(){
			window.location = 'http://imagetransfers.com/order.php';
		});
		$('#place-online-order').on('click touchend', function(){
			window.location = 'order.php';
		});
		$('#register-button').on('click touchend', function(){
			window.location = 'register.php';
		});
		$('#log-in-button').on('click touchend', function(){
			window.location = 'account.php';
		});
		$('#edit-order').on('click touchend', function(){
			window.location = 'account-summary.php';
		});

		if ($( '#testimonials-slideshow' ).length) {

		if (localStorage.getItem("activeSlide")){

			var activeSlide  = localStorage.getItem("activeSlide");
			$('#testimonials-slideshow').children().removeClass('active').eq(activeSlide).addClass('active');

		}
		var testimonialInterval = setInterval( function() {
			slideshowAuto('#testimonials-slideshow');
		}, slideShowInterval);

		paused = false;

		$('#testimonial-forward').on('click', function(){
			//console.log('forward');
			//clearInterval(testimonialInterval);
			slideshowNext('#testimonials-slideshow');
			if (paused === false) {
			$('#testimonial-pause').click();
			}
		});

		$('#testimonial-back').click(function(){
			//console.log('back');
			//clearInterval(testimonialInterval);
			slideshowBack('#testimonials-slideshow');
			if (paused === false) {
			$('#testimonial-pause').click();
			}
		});

		$('#testimonial-pause').clickToggle(function() {
			paused = true;
			clearInterval(testimonialInterval);
			$(this).removeClass('icon-pause');
			$(this).addClass('icon-play');
		},
		function() {
			paused = false;
			slideshowNext('#testimonials-slideshow');
			testimonialInterval = setInterval( function() {
				slideshowAuto('#testimonials-slideshow');
			}, slideShowInterval);
			$(this).addClass('icon-pause');
			$(this).removeClass('icon-play');
		});

		window.onbeforeunload = function() {
			var activeSlide = $('#testimonials-slideshow').find('.active').index();

			localStorage.setItem("activeSlide", activeSlide);
		};
		}

		if ( $( '#forgot-password' ).length > 0 ) {
			$("#forgot-password").validate({
				errorElement: "div",
				rules: {
					email: {
						email: true
					}
				}
			});
		}
		if ( $( '#log-in-form' ).length > 0 ) {
			$("#log-in-form").validate({
				errorElement: "div",
				messages: {
					username: {
						required: "Please enter your username or email address"
					},
					password: {
						required: "Please enter your password"
					}
				}
			});
		}
		
		if ( $( '#registrationEditForm' ).length > 0 ) {
			$("#registrationEditForm").validate({
				errorElement: "div",
				rules: {
					password2: {
						equalTo: "#password",
						notequalTo: "#username"
					},
					phone: {
						phone: true
					},
					fax: {
						phone: true,
						required: false
					},
					email: {
						email: true
					},
					street: {
						minlength: 2
					},
					city: {
						minlength: 2
					},
					zip: {
						digits: true,
						minlength: 5,
						maxlength: 5
					},
					username: {
						username: true,
						minlength: 4,
						maxlength: 25,
						illegal: true
					},
					password: {
						minlength: 4,
						maxlength: 25,
						notequalTo: "#username"
					}
				},
				messages: {
					firstName: {
						required: "Please enter your first name"
					},
					lastName: {
						required: "Please enter your last name"
					},
					email: {
						required: "Please enter your email"
					},
					phone: {
						required: "Please enter your phone number"
					},
					street: {
						required: "Please enter your address"
					},
					city: {
						required: "Please enter your city"
					},
					state: {
						required: "Please enter your state"
					},
					fax: {
						phone: "Please enter a valid fax number"
					},
					zip: {
						required: "Please enter your zip code",
						digits: "Please enter numbers only",
						minlength: "Please enter a valid zip code: (5 digits)",
						maxlength: "Please enter a valid zip code: (5 digits)"
					},
					password2: {
						required: "Please confirm your password",
						equalTo: "Passwords don't match",
						notequalTo: "Password cannot match username"
					},
					password: {
						required: "Please enter a password",
						minlength: "Passwords must be at least 4 characters",
						maxlength: "Passwords may not have more than 25 characters",
						notequalTo: "Password cannot match username"
					},
					oldPassword: {
						required: "Please enter your current password",
						minlength: "Your current password is at least 4 characters",
						maxlength: "Your current password is does not have more than 25 characters"
					}
				}
			});
		}
		if ( $( '#passwordForm' ).length > 0 ) {
			$("#passwordForm").validate({
				errorElement: "div",
				rules: {
					password2: {
						equalTo: "#password",
						notequalTo: "#username"
					},
					password: {
						minlength: 4,
						maxlength: 25,
						notequalTo: "#username"
					}
					},
					messages: {
					password2: {
						equalTo: "Passwords don't match",
						notequalTo: "Password cannot match username"
					},
					password: {
						minlength: "Passwords must be at least 4 characters",
						maxlength: "Passwords may not have more than 25 characters",
						notequalTo: "Password cannot match username"
					}
				}
			});
		}

		$(window).load(function() {
			if ( $( '#browse-click' ).length > 0 ) {
				$('#browse-click').on('click', function () {
					$('#file-type').click();
					//setInterval(intervalFunc, 1);
					return false;
				});
			}
			if ( $( '#imageshow' ).length > 0 ) {
				setInterval( function() {
					imageSwitch('#imageshow');
				}, 5000);
			}
		});
	});
}(window, document, jQuery));
